import { createUseStyles } from 'react-jss';

var styles = {
  buttonWrapper: { display: 'flex', alignItems: 'center' },
  openButtonWrapper: {
    margin: '3rem auto',
    cursor: 'pointer',
    display: 'flex',
    '@media (min-width:1651px)': {
      display: 'none'
    }
  },
  closeButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '@media (min-width:1651px)': {
      display: 'none'
    }
  },
  icon: {
    marginRight: '1rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map